import React, { useState } from 'react';
import { SeatState } from './PokerTable';
import { sitDown, setDealerSeatIndex } from './api';
import Modal from 'react-modal';

interface Props {
  index: number;
  state: SeatState;
  chips: number;
  currentPot: number;
  cards: string[];
  name: string;
  isCurrentlySeated: boolean;
  isDealer: boolean;
  isSmallBlind: boolean;
  isBigBlind: boolean;
  handDescription?: string;
  onSeated: () => void;
  onOpenIntroModal: () => void;
}

export default function({
  index,
  state,
  cards,
  handDescription,
  name,
  chips,
  isCurrentlySeated,
  isDealer,
  isSmallBlind,
  isBigBlind,
  currentPot,
  onSeated,
  onOpenIntroModal,
}: Props) {
  if ([2, 5, 7, 0].includes(index)) {
    return null;
  }
  const [isMakeDealVisible, setMakeDealerVisible] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [sitName, setSitName] = useState('');
  const [sitChips, setSitChips] = useState(500);

  const modalContent = (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={() => setModalOpen(false)}
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          width: '480px',
        },
      }}
    >
      <div className="sit-modal">
        <div className="form-row">
          <label>Name</label>
          <input
            autoFocus
            type="text"
            value={sitName}
            onChange={e => {
              setSitName(e.target.value);
            }}
          />
        </div>
        <div className="form-row">
          <label>Buy-in</label>
          <input
            type="number"
            min={1}
            max={500000000}
            value={sitChips}
            onChange={e => {
              setSitChips(parseInt(e.target.value, 10));
            }}
          />
        </div>
        <button
          disabled={sitChips === 0 || sitName === ''}
          onClick={async () => {
            await sitDown(index, sitName, sitChips);
            onSeated();
            setModalOpen(false);
          }}
        >
          Sit down
        </button>
      </div>
    </Modal>
  );

  if (state !== SeatState.EMPTY) {
    let c1;
    let c2;
    if (cards[0] === 'HIDDEN') {
      c1 = { backgroundImage: `url('/assets/red_back.png')` };
    } else if (cards[0] === 'FOLDED') {
      c1 = { backgroundImage: `url('/assets/red_back.png')`, opacity: 0.25 };
    } else {
      if (state === SeatState.FOLDED) {
        c1 = {
          backgroundImage: `url('/assets/${cards[0]}.png')`,
          opacity: 0.25,
        };
      } else {
        c1 = {
          backgroundImage: `url('/assets/${cards[0]}.png')`,
        };
      }
    }

    if (cards[1] === 'HIDDEN') {
      c2 = { backgroundImage: `url('/assets/red_back.png')` };
    } else if (cards[1] === 'FOLDED') {
      c2 = { backgroundImage: `url('/assets/red_back.png')`, opacity: 0.25 };
    } else {
      if (state === SeatState.FOLDED) {
        c2 = {
          backgroundImage: `url('/assets/${cards[1]}.png')`,
          opacity: 0.25,
        };
      } else {
        c2 = {
          backgroundImage: `url('/assets/${cards[1]}.png')`,
        };
      }
    }

    return (
      <>
        <div
          onMouseEnter={() => setMakeDealerVisible(true)}
          onMouseLeave={() => setMakeDealerVisible(false)}
          className={`seat-v2 seat-${index}`}
        >
          {isMakeDealVisible === true && isDealer === false && (
            <button
              onClick={() => setDealerSeatIndex(index)}
              onMouseOver={() => setMakeDealerVisible(true)}
            >
              Make dealer
            </button>
          )}
          <div
            className={`video`}
            id={`seat-${index + 1}-video`}
            style={{
              background: `url('/assets/noise.gif')`,
              backgroundPosition: 'center',
            }}
          >
            <div className="hole-cards">
              <div className="card holecard1" style={c1} />
              <div className="card holecard2" style={c2} />
            </div>
          </div>

          <div className="name-chips">
            <div className="left">
              {handDescription && <b>"{handDescription}"</b>}
              <div className="player-name">{name}</div>
              <div className="chips">${chips}</div>
              {currentPot !== 0 && (
                <div>
                  <span className="current-bet">
                    Bet: <b>${currentPot}</b>
                  </span>
                </div>
              )}
            </div>

            <div className="right">
              <div className="table-button">
                {isDealer && <div className={`dealer-button`}>D</div>}
                {isSmallBlind && <div className={`small-blind-button`}>S</div>}
                {isBigBlind && <div className={`big-blind-button`}>B</div>}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div
          onClick={() => {
            isCurrentlySeated ? onOpenIntroModal() : setModalOpen(true);
          }}
          className={`seat empty seat-${index}`}
        >
          <div>
            {isCurrentlySeated ? 'Invite' : 'Sit'}
            <br />
            {/* <small>Seat {index + 1}</small>{' '} */}
          </div>
        </div>
        {modalContent}
      </>
    );
  }
}
